export { default } from './MAPFeatureActivation';
